import { Box, useTheme } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { Expo, Sine, gsap } from "gsap";

const Loader = () => {
  const theme = useTheme();
  let logosvg = useRef(null);

  const loadStart = () => {
    const logo = logosvg.current;

    gsap.fromTo(
      logo,
      { strokeDashoffset: 4500 },
      {
        strokeDashoffset: 3500,
        duration: 2,
        ease: Sine.easeInOut,
        repeat: -1,
        yoyo: true,
        repeatDelay: 1,
      }
    );
  };

  const loadFin = () => {
    const logo = logosvg.current;
    gsap.killTweensOf(logo);
    gsap.fromTo(
      logo,
      { strokeDashoffset: 4500 },
      { strokeDashoffset: 3500, duration: 2, ease: Sine.easeInOut }
    );
    gsap.to(".containerLogo", {
      delay: 2,
      y: "-25px",
      opacity: 0,
      duration: 2,
      ease: "ease",
    });
    gsap.to(".loader", {
      delay: 4,
      top: "-100vh",
      opacity: 0,
      duration: 3,
      ease: Expo.easeInOut,
      display: "none",
    });
  };
  useEffect(() => {
    loadStart();
    // setTimeout(loadFin, 10000);
    const pageLoad = () => {
      if (document.readyState === "complete") {
        loadFin();
        console.log("loaded");
      } else {
        window.addEventListener("load", loadFin);
      }
    };
    pageLoad();
  }, []);

  if (window.location.pathname === "/") {
    return (
      <Box
        position="fixed"
        left="0"
        top="0"
        width="100%"
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          backgroundColor: theme.palette.primary.main,
          zIndex: "999",
          color: theme.palette.background.main,
        }}
        className="loader"
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          sx={{ transform: "translate(-50%,-50%) scale(0.8)" }}
          className="containerLogo"
        >
          <svg
            id="svg"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="400"
            height="400"
            viewBox="0, 0, 400,400"
            ref={logosvg}
          >
            <g id="svgg">
              <path
                id="path0"
                d="M177.410 48.087 C 175.895 48.310,171.021 49.028,166.579 49.684 C 143.424 53.104,111.129 68.096,94.021 83.369 C 92.557 84.677,89.363 87.373,86.925 89.360 C 65.169 107.093,45.564 143.425,39.650 176.969 C 34.212 207.812,40.852 251.887,53.993 272.176 C 54.582 273.085,55.758 275.365,56.606 277.241 C 70.699 308.418,114.689 342.639,153.719 352.791 C 287.497 387.584,397.916 247.753,331.801 127.273 C 302.605 74.070,235.361 39.581,177.410 48.087 M222.039 63.344 C 273.122 75.316,315.004 110.052,328.345 151.515 C 329.126 153.939,330.141 156.419,330.603 157.025 C 331.064 157.631,332.033 161.102,332.756 164.738 C 333.479 168.375,334.863 174.077,335.831 177.410 C 340.321 192.867,337.104 232.688,330.088 248.485 C 329.280 250.303,328.257 253.030,327.814 254.545 C 326.785 258.061,320.473 271.449,319.501 272.176 C 319.096 272.479,317.899 274.416,316.841 276.480 C 315.783 278.545,313.978 281.241,312.831 282.473 C 311.683 283.705,310.744 285.080,310.744 285.529 C 310.744 285.977,310.124 287.003,309.366 287.808 C 308.609 288.613,305.564 292.156,302.599 295.682 C 298.043 301.102,290.439 308.132,280.198 316.394 C 272.519 322.590,251.550 333.564,242.424 336.163 C 239.697 336.940,236.965 337.947,236.353 338.400 C 235.343 339.148,228.642 340.461,208.264 343.903 C 196.338 345.918,157.149 342.014,152.692 338.368 C 152.045 337.839,149.284 336.811,146.556 336.084 C 137.772 333.742,116.616 322.715,108.782 316.394 C 94.339 304.742,86.577 296.877,77.651 284.849 C 69.619 274.025,60.796 256.217,57.724 244.628 C 56.840 241.295,55.649 237.576,55.077 236.364 C 50.706 227.107,50.662 178.947,55.015 169.146 C 55.553 167.934,56.609 164.463,57.361 161.433 C 64.296 133.473,93.417 95.584,118.197 82.277 C 119.552 81.549,121.901 80.135,123.416 79.135 C 132.760 72.968,156.620 65.067,176.309 61.619 C 184.291 60.221,213.401 61.319,222.039 63.344 M184.022 100.293 C 184.022 103.277,186.928 110.193,188.182 110.193 C 190.588 110.193,191.033 106.870,189.155 102.930 C 187.506 99.472,184.022 97.682,184.022 100.293 M196.731 103.107 C 194.747 107.289,195.098 110.193,197.587 110.193 C 198.937 110.193,201.653 103.666,201.653 100.423 C 201.653 97.680,198.488 99.406,196.731 103.107 M209.488 105.119 C 206.384 106.839,203.951 110.846,203.896 114.325 C 203.842 117.737,204.296 117.535,209.966 111.617 C 216.112 105.203,215.847 101.595,209.488 105.119 M171.528 105.510 C 170.500 107.199,180.741 117.220,182.103 115.858 C 183.505 114.456,180.754 108.648,177.480 106.096 C 175.538 104.582,172.287 104.262,171.528 105.510 M162.204 115.923 C 160.492 117.634,160.517 119.007,162.259 119.012 C 163.017 119.015,166.612 120.500,170.248 122.314 C 179.909 127.132,183.147 125.936,176.584 119.973 C 171.213 115.093,164.831 113.296,162.204 115.923 M214.008 116.208 C 210.283 118.265,206.061 122.489,206.061 124.159 C 206.061 126.309,208.695 125.944,213.413 123.140 C 215.708 121.777,219.078 120.165,220.901 119.559 C 222.724 118.953,224.382 117.590,224.585 116.529 C 225.037 114.172,218.080 113.961,214.008 116.208 M162.438 127.737 C 154.308 129.738,154.215 132.828,162.259 133.723 C 165.441 134.077,170.895 134.687,174.380 135.079 C 178.441 135.535,180.716 135.385,180.716 134.660 C 180.716 132.984,174.224 127.826,172.092 127.809 C 171.078 127.800,169.256 127.592,168.044 127.346 C 166.832 127.100,164.309 127.276,162.438 127.737 M213.189 127.892 C 205.766 130.051,202.198 136.318,209.091 135.089 C 211.364 134.684,216.818 134.052,221.212 133.684 C 227.938 133.121,229.201 132.700,229.201 131.022 C 229.201 127.619,220.187 125.856,213.189 127.892 M172.115 140.099 C 166.909 141.308,157.576 149.222,157.576 152.428 C 157.576 154.942,158.311 154.809,167.631 150.602 C 172.101 148.585,178.237 146.280,181.267 145.481 C 193.929 142.141,185.264 137.045,172.115 140.099 M200.213 139.615 C 196.512 140.574,198.766 143.536,204.408 145.128 C 207.438 145.983,211.405 147.340,213.223 148.145 C 215.041 148.950,218.388 150.261,220.661 151.059 C 222.934 151.856,224.793 152.905,224.793 153.389 C 224.793 153.874,225.537 154.270,226.446 154.270 C 232.171 154.270,222.577 142.382,215.027 140.120 C 210.798 138.853,204.041 138.623,200.213 139.615 M185.675 146.216 C 178.052 147.814,169.162 158.598,167.909 167.769 C 166.815 175.775,169.190 174.071,187.999 153.354 L 192.332 148.582 201.429 157.834 C 206.433 162.922,211.285 168.169,212.213 169.493 C 215.362 173.989,217.469 172.596,216.747 166.496 C 215.101 152.598,200.548 143.100,185.675 146.216 M189.665 154.902 C 184.950 160.896,190.400 168.822,195.422 163.274 C 197.977 160.450,197.692 157.278,194.623 154.395 L 192.001 151.932 189.665 154.902 M78.237 207.801 L 78.237 262.434 104.408 262.011 C 127.095 261.644,131.300 261.302,136.002 259.444 C 142.547 256.857,152.919 247.713,153.880 243.683 C 154.261 242.082,155.056 240.159,155.645 239.410 C 162.104 231.204,151.543 207.082,140.250 204.248 C 136.877 203.401,137.095 202.640,141.528 199.769 C 156.302 190.201,156.628 168.680,142.143 159.094 C 134.878 154.287,127.462 153.204,101.653 153.185 L 78.237 153.168 78.237 207.801 M235.813 164.174 L 235.813 175.207 249.469 175.207 C 260.905 175.207,263.234 175.490,263.794 176.950 C 264.162 177.908,264.463 197.495,264.463 220.476 L 264.463 262.259 275.392 262.259 C 281.403 262.259,287.105 261.958,288.064 261.590 C 289.612 260.996,289.807 256.131,289.807 218.097 L 289.807 175.272 303.857 174.964 L 317.906 174.656 317.906 164.187 L 317.906 153.719 276.860 153.430 L 235.813 153.141 235.813 164.174 M121.309 174.888 C 132.582 181.547,124.959 196.143,110.208 196.143 L 103.581 196.143 103.581 184.573 L 103.581 173.003 110.849 173.003 C 115.730 173.003,119.166 173.622,121.309 174.888 M164.453 175.019 C 163.361 175.713,163.126 187.856,163.351 232.027 L 163.636 288.154 175.758 288.154 L 187.879 288.154 188.164 232.027 C 188.389 187.856,188.155 175.713,187.063 175.019 C 186.299 174.535,181.212 174.138,175.758 174.138 C 170.303 174.138,165.216 174.535,164.453 175.019 M204.627 174.803 C 204.204 175.227,203.857 201.045,203.857 232.177 L 203.857 288.780 215.702 288.467 L 227.548 288.154 227.548 231.405 L 227.548 174.656 216.473 174.344 C 210.382 174.173,205.051 174.379,204.627 174.803 M126.171 219.629 C 137.754 229.642,128.520 242.424,109.705 242.424 L 103.581 242.424 103.581 229.201 L 103.581 215.978 112.764 215.978 C 121.576 215.978,122.118 216.125,126.171 219.629 "
              ></path>
            </g>
          </svg>
        </Box>
      </Box>
    );
  } else {
    return null;
  }
};

export default Loader;
